import React from "react";
import { Card, CardBody, Container, Row, Col } from "reactstrap";
import { Stepper, Step, StepLabel } from "@material-ui/core";

const BulkDocumentStepperHeader = ({ currentStep, steps, user }) => {
  return (
    <>
      <style>
        {`
          .generate-quote {
            
            font-family: 'Poppins', sans-serif;
          }

          .row-container {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            width: 100%;
            gap: 15px;
            margin-bottom: 15px;
          }

          .name-section {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          }

          .sub-text {
            font-size: 11px;
            color: #999;
            margin: 0;
            font-weight: 400;
          }

          .usrName {
            font-size: 15px;
            font-weight: bold;
            color: #333;
            margin-top: 0;
            margin-bottom: 0;
          }

          .years-wrapper {
            display: flex;
            gap: 20px;
            align-items: flex-start;
            flex: 1;
            justify-content: flex-end;
          }

          .years-section {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            text-align: left;
          }

          .bold-text {
            font-size: 14px;
            font-weight: bold;
            color: #333;
            margin-bottom: 0;
          }
        `}
      </style>

      <div className="generate-quote">
        <div className="row-container" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
          <div className="name-section">
            <div className="sub-text" style={{ marginBottom: "0px" }}>Hello,</div>
            <div className="usrName" style={{ marginTop: "0px" }}>{user?.name || 'User'}</div>
          </div>
          <div className="years-wrapper">
            <div className="years-section" style={{ marginBottom: "0px" }}>
              <div className="bold-text" style={{ marginBottom: "0px" }}>17 Years</div>
              <div className="sub-text" style={{ marginTop: "0px" }}>of care services in India</div>
            </div>
            <div className="years-section" style={{ marginBottom: "0px" }}>
              <div className="bold-text" style={{ marginBottom: "0px" }}>60* Million</div>
              <div className="sub-text" style={{ marginTop: "0px" }}>Indians Protected</div>
            </div>
            <div className="years-section">
              <div className="bold-text" style={{ marginBottom: "0px" }}>2.4* Million</div>
              <div className="sub-text" style={{ marginTop: "0px" }}>Assistance Cases Managed</div>
            </div>
          </div>
        </div>

        <Stepper activeStep={currentStep} alternativeLabel>
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel
                StepIconProps={{
                  style: {
                    backgroundColor:
                      index < currentStep
                        ? "#00239c"
                        : currentStep === index
                        ? "#00239c"
                        : "#f2b90f",
                    color: index < currentStep ? "#00239c" : "#00239c",
                    borderRadius: "50%",
                    width: currentStep === index ? "35px" : "26px",
                    height: currentStep === index ? "35px" : "26px",
                    border: index > currentStep
                      ? `12px solid #f2b90f`
                      : "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: currentStep === index ? "16px" : "12px",
                    fontWeight: "bold",
                    pointerEvents: index < currentStep ? "none" : "auto",
                    opacity: index < currentStep ? 0.6 : 1,
                  },
                  children: index + 1,
                }}
              >
                {label.name}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
    </>
  );
};

export default BulkDocumentStepperHeader;
